<script lang="ts">
	import { onMount } from 'svelte';
	if (import.meta.env.VITE_NR_APPLICATION_ID) {
		onMount(async () => {
			// Load NR Browser Agent inside onMount to avoid SSR issues
			const { BrowserAgent } = await import('@newrelic/browser-agent/loaders/browser-agent');
			new BrowserAgent({
				info: {
					applicationID: import.meta.env.VITE_NR_APPLICATION_ID,
					beacon: 'bam.nr-data.net',
					errorBeacon: 'bam.nr-data.net',
					licenseKey: import.meta.env.VITE_NR_LICENSE_KEY,
					sa: 1,
				},
				init: {
					ajax: { deny_list: ['bam.nr-data.net'] },
					session_replay: {
						enabled: true,
						block_selector: '',
						mask_text_selector: '*',
						sampling_rate: 10.0,
						error_sampling_rate: 100.0,
						mask_all_inputs: true,
						collect_fonts: true,
						inline_images: false,
						fix_stylesheets: true,
						preload: false,
						mask_input_options: {},
					},
					session_trace: { enabled: true },
					distributed_tracing: { enabled: true },
					performance: { capture_detail: false, capture_marks: false, capture_measures: true },
					privacy: { cookies_enabled: true },
				},
				loader_config: {
					accountID: import.meta.env.VITE_NR_ACCOUNT_ID,
					agentID: import.meta.env.VITE_NR_APPLICATION_ID,
					applicationID: import.meta.env.VITE_NR_APPLICATION_ID,
					licenseKey: import.meta.env.VITE_NR_LICENSE_KEY,
					trustKey: import.meta.env.VITE_NR_ACCOUNT_ID,
				},
			});
		});
	}
</script>
